var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { service } from "@ember/service";
import IntlService from "ember-intl/services/intl";
import emberSwal from "ui-kit/utils/ember-swal";
let ErrorsService = (_class = class ErrorsService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  displayError(e) {
    emberSwal.fire("Oops...", e, "error");
  }
  defineErrors(e) {
    console.error(e);
    this.defineResourceCreationErrors(e);
  }

  /**
   * Errors returned by the API have the following format:
   *
   * {"errors":[
   *   {"title":"n'est pas disponible",
   *    "detail":"social-security-number - n'est pas disponible",
   *    "code":"100",
   *    "source":{"pointer":"/data/attributes/social-security-number"},
   *    "status":"422"}
   * ]}
   *
   * Error codes are defined [here](https://github.com/cerebris/jsonapi-resources/blob/c4242e32b78b9a31e81c2df153454da4a1e831bd/lib/jsonapi/error_codes.rb).
   */
  defineResourceCreationErrors(e) {
    let errorMessage;
    if (e.errors?.[0].status == "409") {
      const error = e.errors[0];
      // This is a validation error
      if (error.code == "100") {
        const attributeUniquenessErrorMessages = ["n'est pas disponible", "has already been taken", "est déjà utilisé(e)"];
        if (attributeUniquenessErrorMessages.includes(error.title)) {
          const attribute = error.detail.split(" - ")[0];
          errorMessage = `Un patient avec le même ${this.intl.t(`patient.${attribute}`)} existe déjà. Si vous pensez ne pas avoir fait d’erreur de saisie, veuillez contacter le support pour vérification. <br /><a href="mailto:support@semeia.io">support@semeia.io</a>.`;
        }
      }
    }
    if (e.errors?.[0].status == "422") {
      const error = e.errors[0];
      // This is a validation error
      if (error.code == "100") {
        const patientDuplicateMessage = "may be a patient duplicate";
        if (patientDuplicateMessage.includes(error.title)) {
          errorMessage = "Un patient avec le même nom, le même prénom et la même date de naissance existe déjà.<br /><br />Merci de contacter support@semeia.io";
        }
      }
    }
    errorMessage ||= `Une erreur est survenue. Merci de contacter support@semeia.io.`;
    this.displayError(errorMessage);
  }
  showPendingChangesetError() {
    return emberSwal.fire({
      title: "Vous avez des changements non sauvegardés.",
      text: "Êtes-vous sûr de vouloir quitter ?",
      icon: "warning",
      cancelButtonText: "Annuler",
      showCancelButton: true,
      confirmButtonText: "Oui, quitter",
      confirmButtonColor: "#d33"
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ErrorsService as default };